import { html, nothing, render } from "lit-html";
import { createRef, ref } from "lit-html/directives/ref.js";

// TODO: This class can be simplified by using the "Popover" html element and anchor positioning,
//			 once the later is widely available.
//			 @see:
//			 - https://developer.mozilla.org/en-US/docs/Web/API/Popover_API
//			 - https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_anchor_positioning
customElements.define(
	"esc-information-dropdown",
	class extends HTMLElement {
		constructor() {
			super();
			this.renderEnabled = false;
		}

		static get observedAttributes() {
			return ["open"];
		}

		attributeChangedCallback(name, oldValue, newValue) {
			if (name === "open") {
				if (newValue !== null && !this.renderEnabled) {
					this.renderEnabled = true;
					this.render();
					setTimeout(() => this.setAttribute("rendered", ""));
				}
				this.dispatchEvent(
					new CustomEvent("change", { detail: { open: newValue !== null } }),
				);
			}
		}

		connectedCallback() {
			this.render();
			this.detailsLink = createRef();
		}

		render() {
			render(this.getTemplate(), this, { host: this });
		}

		getTemplate() {
			return this.renderEnabled
				? html`<div
						class="information-dropdown__info-dropdown-text"
						@click=${this.onInfoClick}
					>
						<button
							class="close-icon close-icon--with-hover"
							@click=${this.onCloseClick}
						></button>
						${this.confirmationText}
						${this.detailsUrl && this.detailsLabel
							? html`<a
									href=${this.detailsUrl}
									target="_blank"
									class="text-underline"
									${ref(this.detailsLink)}
									>${this.detailsLabel}</a
								>`
							: nothing}
					</div>`
				: nothing;
		}

		onCloseClick() {
			this.removeAttribute("open");
		}

		onInfoClick(event) {
			event.stopPropagation();
			if (!this.detailsLink?.value || event.target !== this.detailsLink.value) {
				// Prevent triggering outside links.
				event.preventDefault();
			}
		}

		get confirmationText() {
			return this.getAttribute("info-text") || "";
		}

		get detailsUrl() {
			return this.getAttribute("details-url");
		}

		get detailsLabel() {
			return this.getAttribute("details-label");
		}
	},
);
